export const UPCOMING_BOOKINGS_LIST_START = "UPCOMING_BOOKINGS_LIST_START";
export const UPCOMING_BOOKINGS_LIST_SUCCESS = "UPCOMING_BOOKINGS_LIST_SUCCESS";
export const UPCOMING_BOOKINGS_LIST_ERROR = "UPCOMING_BOOKINGS_LIST_ERROR";

export const ONGOING_BOOKINGS_LIST_START = "ONGOING_BOOKINGS_LIST_START";
export const ONGOING_BOOKINGS_LIST_SUCCESS = "ONGOING_BOOKINGS_LIST_SUCCESS";
export const ONGOING_BOOKINGS_LIST_ERROR = "ONGOING_BOOKINGS_LIST_ERROR";

export const COMPLETED_BOOKINGS_LIST_START = "COMPLETED_BOOKINGS_LIST_START";
export const COMPLETED_BOOKINGS_LIST_SUCCESS =
  "COMPLETED_BOOKINGS_LIST_SUCCESS";
export const COMPLETED_BOOKINGS_LIST_ERROR = "COMPLETED_BOOKINGS_LIST_ERROR";

export const CANCELLED_BOOKINGS_LIST_START = "CANCELLED_BOOKINGS_LIST_START";
export const CANCELLED_BOOKINGS_LIST_SUCCESS =
  "CANCELLED_BOOKINGS_LIST_SUCCESS";
export const CANCELLED_BOOKINGS_LIST_ERROR = "CANCELLED_BOOKINGS_LIST_ERROR";

export const ADMIN_BOOKING_LIST_ERROR = "ADMIN_BOOKING_LIST_ERROR";
export const ADMIN_BOOKING_LIST_START = "ADMIN_BOOKING_LIST_START";
